<template>
    <div class="doctor_list_details">
         <router-view v-wechat-title='$route.meta.title'></router-view>
        <div class="header">
            <div class="doctor_box">
                <img :src="details.PicUrl" class="head_img">
                <div class="name">{{details.Name}}</div>
                <div class="flex2 pos_dep_box">
                    <!-- <div class="joint1">莲藕互联网医院</div> -->
                    <div class="position joint1">{{details.Professional}}</div>
                    <div class="joint1" style="margin:0 5px">•</div>
                    <div class="department joint1">{{details.Department}}</div>
                </div>

                <!-- <div class="flex2 pos_dep_box inquery_btn_item">
                    <div class="pic_inquery">图文问诊</div>
                    <div class="pic_inquery">视频问诊</div>
                    <div class="joint3">语音问诊</div>
                </div> -->


            </div>
        </div>
        <div class="content">
            <div class="title">
                <img src="@/images/shanChang.png" alt="">
            </div>
            <div class="contents">
                <span v-for="(item,i) in details.GoodAt" :key="i">{{item}}</span>
            </div>
        </div>
        <div class="content content2">
            <div class="title">
                <img src="@/images/jianJie.png" alt="">
            </div>
            <pre class="contents">{{details.Introduction}}</pre>
        </div>
        <div class="goto_fill" @click="showTip=true" v-if="details.Name">立即问诊</div>
        <div class="mask" v-if="showTip" @click="showTip=false">
            <showTip></showTip>
        </div>
    </div>
</template>

<script>
import { DropdownMenu, DropdownItem, Toast } from 'vant';
import {SearchDoctor,GetDoctorInfo} from "@/utils/api.js"
import showTip from "@/components/doctorDetail/showTip"
export default {
    components:{
        showTip
    },
    data(){
        return{
            details:{},
            showTip:false
        }
    },
    methods:{

        getData(){
            console.log(this.$route.query)
            GetDoctorInfo({
                id:this.$route.query.id,
                pageIndex:1,
                pageSize:1
            }).then(res=>{
                console.log(res)
                if(res.code==1){
                    this.details = res.data
                    if(this.details.GoodAt){
                        this.details.GoodAt = this.details.GoodAt.split('、')
                    }
                }else{
                    Toast(res.msg)
                }
            })
        }
    },
    mounted(){
        this.getData()
    }
}
</script>

<style lang="scss" scoped>
.doctor_list_details{
    .mask{
        position: fixed ;
        width: 100%;
        left: 0;
        top: 0;
        height: 100%;
        background: rgba(0,0,0,.5);
    }
    height: 90%;
    overflow-y: auto;
    .header{
        background-image: url("../images/detail_1.png");
        background-size: 100% 100%;
        width: 100%;
        height: 151px;
        position: relative;
        .doctor_box{
            padding-top: 51px;
            box-sizing: border-box;
            text-align: center;
            background-color: #fff;
            width:345px;
            height:162px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 13px 0px rgba(239,239,239,0.7);
            border-radius:10px;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translate(-50%,-50%);
            .head_img{
                width: 55px;
                height: 55px;
                border-radius: 50%;
                border: 3px solid #fff;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%,-50%);

            }
            .name{
                font-size:20px;
                font-family:STXihei;
                font-weight:bold;
                color:rgba(51,51,51,1);
            }
            .pos_dep_box{
                justify-content: center;
                margin-top: 8px;

                .joint1{
                    font-size:14px;
                    font-weight:500;
                    color:#999;
                }
                .position{
                    margin: 0 0px 0 0 ;
                }
                .pic_inquery{
                    color:rgba(255,255,255,1);
                    background:#FF9130;
                    margin-right: 5px;
                }
                .joint3{
                        color:#FF9130;
                        background:rgba(255,145,48,.15);
                    
                }
            }
            .inquery_btn_item>div{
                width:60px;
                height:20px;
                border-radius:2px;
                text-align: center;
                line-height: 20px;
                font-size: 11px;
                font-family:STXihei;
            }

        }
    }
    .content{
        padding: 0 15px;
        padding-top: 127px;
        // img {
        //     width: 80px;
        // }
        .title{
            width: 80px;
            // position: relative;
        }
        .contents{
            margin-top: 10px;
            font-size:14px;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            span{
                padding: 3px 4px;
                color:#999;
                border:1px solid #bcc0cf;
                border-radius: 4px;
                margin: 0 5px 5px 0;
            }
        }

    }
    .content.content2{
        padding-top: 70px;
        padding-bottom: 20px;
        .contents {
            color: #999;
            width: 100%;
            white-space:pre-wrap;
        }
    }
        .goto_fill{
            width:300px;
            height:42px;
            background:#807AF4;
            // box-shadow:0px 0px 5px 0px rgba(22,174,202,0.4);
            border-radius:20px;
            position: fixed;
            bottom:4%;
            text-align: center;
            line-height: 42px;
            font-size:18px;
            color:rgba(255,255,255,1);
            left: 50%;
            transform: translateX(-50%);
        }
}

</style>
